import React, { useState } from 'react';
import { Modal, Form, Input, Select, message } from 'antd';
import { orderApi } from '../../../../services/process/order';
import { MergedOrder } from '../../../../types/process/order';

const { TextArea } = Input;
const { Option } = Select;

export interface InterceptRequestModalProps {
  visible: boolean;
  order: MergedOrder | null;
  onCancel: () => void;
  onSuccess: () => void;
}

const INTERCEPT_REASONS = [
  '疑似套现',
  '材料造假',
  'D类订单',
  '其他'
];

const InterceptRequestModal: React.FC<InterceptRequestModalProps> = ({ visible, order, onCancel, onSuccess }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [isOtherReason, setIsOtherReason] = useState(false);

  const handleSubmit = async () => {
    if (!order) return;
    try {
      const values = await form.validateFields();
      setLoading(true);
      
      const finalReason = values.reasonType === '其他' 
        ? values.customReason 
        : values.reasonType;

      await orderApi.changeStatus(order.order.orderNo, 'preprocessing:ship_intercept' as any, { reason: finalReason });
      message.success('已下发拦截申请');
      onSuccess();
    } catch (error: any) {
      if (error?.errorFields) return;
      message.error(error.message || '操作失败');
    } finally {
      setLoading(false);
    }
  };

  const handleReasonTypeChange = (value: string) => {
    setIsOtherReason(value === '其他');
  };

  return (
    <Modal
      title="下发拦截申请"
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      confirmLoading={loading}
      destroyOnClose
    >
      <Form form={form} layout="vertical" preserve={false}>
        <Form.Item
          name="reasonType"
          label="拦截原因"
          rules={[{ required: true, message: '请选择拦截原因' }]}
        >
          <Select placeholder="请选择拦截原因" onChange={handleReasonTypeChange}>
            {INTERCEPT_REASONS.map(reason => (
              <Option key={reason} value={reason}>{reason}</Option>
            ))}
          </Select>
        </Form.Item>
        
        {isOtherReason && (
          <Form.Item
            name="customReason"
            label="具体原因"
            rules={[{ required: true, message: '请输入具体拦截原因' }]}
          >
            <TextArea rows={4} placeholder="请输入具体拦截原因..." />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

export default InterceptRequestModal;
